// Utilidad para formatear la URL de zoom de imágenes
export default function formatUrlZoom(originalUrl) {
  if (typeof originalUrl !== 'string') return originalUrl ?? '';
  const formats = 'if_w_gt_1000/c_scale,w_1000/if_end';
  return originalUrl.replace('if_w_gt_300/c_scale,w_300/if_end', formats);
}
